import * as React from 'react';
import '@common/bugsnag/bug-reporting-init';
import { BugReportingBoundary } from '@common/bugsnag/bug-reporting-boundary';
// import App from './app';
import ReactDOM from 'react-dom';
import { configure } from 'mobx';
import { SpaGlobalStyles } from 'components/ui/spa-global-styles';
import { createLogger } from '@common/log';
import { UpdateManager } from 'pwa/window/update-manager';
import { appConfig } from '@app/config';
import { L2Router } from 'l2-router';

// only imported now when localization is enabled
// import 'lib/services/localization-service';

const log = createLogger('index');

log.debug('loading src/index.tsx');

/// hack to mock window.process, for some reason our markdown library requires it
(window as any).process = { cwd: () => '' };

const { updatePollingEnabled } = appConfig;

log.debug(`updatePollingEnabled: ${String(updatePollingEnabled)}`);

// disable mobx strict-mode
configure({
  enforceActions: 'never',
});

ReactDOM.render(
  <BugReportingBoundary>
    <SpaGlobalStyles />
    {/* <App /> */}
    <L2Router />

    {updatePollingEnabled ? <UpdateManager /> : null}
  </BugReportingBoundary>,
  document.getElementById('root')
);

// // useful for isolated scratch code testing
// ReactDOM.render(
//   <BugReportingBoundary bugsnagStatic={Bugsnag} bugsnagEnabled={bugsnagEnabled}>
//     <h2>scratch</h2>
//   </BugReportingBoundary>,
//   document.getElementById('root')
// );

// (window as any).initMp = () => {
//   (window as any).mp = new MixpanelAnalytics();
// };
